import { Button } from '@/global/components/Button'
import { Calendar } from '@/global/components/ui/calendar'
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '@/global/components/ui/popover'
import { cn } from '@/lib/utils'
import dayjs from 'dayjs'
import { Calendar1Icon, CalendarPlus2Icon } from 'lucide-react'
import { useState } from 'react'

/** Formato que as colunas `date` entregam e esperam de volta no commit. */
const FORMATO_VALOR = 'YYYY-MM-DD'

interface IPropsEditableDateCell {
    id: string
    value: string | null
    className: string
    style: React.CSSProperties
    /** Recebe `YYYY-MM-DD`, ou `''` ao limpar — o mesmo do input nativo. */
    onCommit: (value: string) => void
}

/**
 * Célula editável de data com o calendário do app no lugar do seletor nativo
 * do navegador. Exibe `DD/MM/YYYY` e grava ao escolher o dia.
 */
export default function EditableDateCell({
    id,
    value,
    className,
    style,
    onCommit,
}: IPropsEditableDateCell) {
    const [isAberto, setAberto] = useState(false)
    const data = value ? dayjs(value) : null

    const selecionar = (novoValor: string) => {
        setAberto(false)
        onCommit(novoValor)
    }

    return (
        <Popover open={isAberto} onOpenChange={setAberto}>
            <PopoverTrigger asChild>
                <button
                    id={id}
                    type="button"
                    className={cn(
                        className,
                        'cursor-pointer outline-none min-w-24 h-6',
                    )}
                    style={style}
                >
                    {data ? (
                        <>
                            <Calendar1Icon className="size-4 text-muted-foreground" />
                            &nbsp;
                            {data.format('DD/MM/YYYY')}
                        </>
                    ) : (
                        <CalendarPlus2Icon className="size-4 text-muted-foreground" />
                    )}
                </button>
            </PopoverTrigger>
            <PopoverContent align="start" arrow={false} className="w-auto p-0">
                <Calendar
                    mode="single"
                    selected={data?.toDate()}
                    defaultMonth={data?.toDate()}
                    onSelect={dia =>
                        selecionar(dia ? dayjs(dia).format(FORMATO_VALOR) : '')
                    }
                />
                <div className="flex items-center justify-between border-t">
                    <Button variant="text" onClick={() => selecionar('')}>
                        Limpar
                    </Button>
                    <Button
                        variant="text"
                        onClick={() =>
                            selecionar(dayjs().format(FORMATO_VALOR))
                        }
                    >
                        Hoje
                    </Button>
                </div>
            </PopoverContent>
        </Popover>
    )
}
